import { RefreshLight } from '@repo/go-icons';
import { Button } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import styles from '../BasicParameters.module.scss';
import type { BasicParametersStore } from '../BasicParameters.store';
import { WellboresSelect } from '../selects/WellboresSelect';
import { WellsSelect } from '../selects/WellsSelect';

type Props = {
  store: BasicParametersStore;
};

export const HeaderSection = observer(function HeaderSection({ store }: Props) {
  const { t } = useTranslation();
  const { currentWellbore } = store;

  return (
    <div className={styles.header}>
      <div className={styles.headerSelectsWrapper}>
        <div className={styles.headerSelectWrapper}>
          <span>{t('settings:well')}</span>
          <WellsSelect store={store} />
        </div>
        <div className={styles.headerSelectWrapper}>
          <span>{t('settings:borehole')}</span>
          <WellboresSelect store={store} />
        </div>
      </div>
      <Button
        disabled={!currentWellbore || store.isBaseParamsLoading}
        icon={<RefreshLight />}
        onClick={() => store.autoSetBaseParams()}
        loading={store.isBaseParamsLoading}
      >
        {t('settings:autoFill')}
      </Button>
    </div>
  );
});
